<template>
  <div>
    <h2 class="main-title">《鱼宿APP用户协议》</h2>
    <p class="content">
      本协议由鱼宿APP（以下简称“本平台”）提供。用户确认，在使用该服务前，已认真阅读本协议内容。若用户代表一方实体签订本协议，请确认获得该实体授权。用户在注册过程中勾选《服务协议》确认同意，即表示用户与本平台达成协议，完全接受本协议项下的全部条款，同意并愿意遵守本协议的规定。如果用户不同意本协议内容，请停止注册程序。
    </p>

    <p class="title">一、定义</p>
    <p class="content">1、用户：指经有效注册后，以其自身名义使用、开发或获得合法授权运营且独立承担法律责任的个人、法人或其他组织等。</p>
    <p class="content">2、鱼宿APP是根据相关法律、法规为拥有房屋所有权或使用权（含转租权）的房东及有租住需求的房客提供在线交易的技术服务平台。 </p>
    <p class="content">3、鱼宿APP数据是指用户在使用本平台服务中产生的相关数据，包括但不限于用户提交的经营数据、个人实名数据、操作行为形成的数据及各类交易数据等。</p>

    <p class="title">二、注册会员</p>
    <p class="content">1、为了使用本平台服务，用户须依照本平台要求注册一个用户账户。</p>
    <p class="content">
      2、用户承诺以真实身份开通本协议下本平台账户，且是具备完全民事权利能力和完全民事行为能力的自然人、法人和其他组织等，依照法律法规和本协定约定对所提供的信息承担相应的法律责任，本平台有权自行或委托第三方，审查用户注册时提供的身份信息是否真实有效。
    </p>
    <p class="content">3、若用户不具备上述条款资格，用户的监护人或代理人将承担因用户的不当注册行为或使用行为导致的一切后果，本平台有权注销该用户账户及终止服务，并有权对相关损失进行索赔。</p>
    <p class="content">4、用户在本平台开通账户后，应妥善保管账户信息，并正确、安全使用，因用户未能保管好该账户和密码而导致的责任由用户承担。</p>
    <p class="content">
      5、若用户发现其账号或密码被他人非法使用或产生异常状况，应及时通知本平台，本平台会采取措施暂停该账户的登录和使用。因用户请求采取行动需合理时间，本平台对在采取行动前已经产生的后果（包括但不限于用户的任何损失）不承担责任。</p>
    <p class="content">
      6、若用户在使用过程中变更相关资料信息，应及时更新真实、准确、完整、有效的资料信息，并按照本平台的要求变更操作。如因用户未及时更新有关信息并通知本平台，用户应承担全部责任及由此导致的损失。</p>

    <p class="title">三、服务说明</p>
    <p class="content">1、本平台中用户包括通过本平台发布其享有所有权或使用权（含转租权）的房源信息，并对依据预订订单为房客提供房屋租赁（短期）服务的自然人或法人及其他组织；同时包括通过本平台预订（承租）房屋的用户。
    </p>
    <p class="content">2、本平台各项服务的所有权和运作权归中本平台拥有。除非本服务条款另有其他明示规定，增加或强化目前本服务的任何新功能，包括所推出的新产品，均受到本服务协议规范。</p>
    <p class="content">
      3、本平台仅为用户提供展示其房源信息服务平台。用户了解且明白，本平台上所有信息均为用户自由发布，用户务必自行核查发布信息的准确性、真实性以及合法性。本平台并不对用户发布信息的准确性、真实性和合法性承担任何法律责任。如用户发现该等发布的信息为虚假、违法信息，请立即向本平台举报，本平台将采取删除与屏蔽，以及其他相应的技术和法律手段阻止此类信息的发布。本平台不对用户所发布的信息的删除或储存失败负责。
    </p>
    <p class="content">
      4、因用户所发布信息欠缺准确性、真实性或合法性导致用户的合法权益受到损害的，本平台不承担任何法律责任，但可根据实际需要配合进行信息的核实与调取；本平台对用户与房东或房客间缔结的任何合同、协议、契约等均不作为参与方或见证方，因上述合同，协议或契约的履行产生的任何争议，本平台不承担任何法律责任，但可根据实际需要配合进行信息的核实与调取。
    </p>
    <p class="content">
      5、关于房屋守则，房东有权针对其发布的房源制定房屋守则，但其房屋守则内容不得违反国家法律法规、本协议内容及本平台发布的各项规则。房客预订前，应当仔细阅读拟预订房源房屋守则，并在租住期间严格遵守。如有违反，所有法律后果由房客自行承担，与本平台无关。
    </p>
    <p class="content">
      6、用户了解并同意，本服务仅依其当前所呈现的状况提供，对于任何用户通讯或个人化设定之失效、删除、传递错误、未予储存或其他任何问题，本平台均不承担任何责任。本平台保留不经事先通知为维修保养、升级或其他目的暂停本服务或部分服务的权利。
    </p>
    <p class="content">
      7、用户间进行与本平台服务有关的各项事宜的沟通应当在本平台在线即时通讯工具进行沟通，如发生用户间纠纷，本平台在线即时通讯工具的沟通记录将成为纠纷解决的重要信息，为更好的保护自身权益，用户应当自行保存交易相关的各类证据或凭证。
    </p>

    <p class="title">四、用户管理</p>
    <p class="content">1、在本平台上使用本平台服务过程中，用户承诺遵守以下约定：</p>
    <p class="content">
      1.1在使用本平台服务过程中实施的所有行为均遵守国家法律、法规等规范文件及本平台各项规则的规定和要求，不违背社会公共利益或公共道德，不损害他人的合法权益，不违反本协议及相关规则。用户如果违反前述承诺，产生任何法律后果的，用户应以自己的名义独立承担所有的法律责任，并确保本平台免于因此产生任何损失。
    </p>
    <p class="content">
      1.2不发布国家禁止发布的信息（除非取得合法且足够的许可），不发布涉嫌侵犯他人知识产权或其它合法权益的信息，不发布违背社会公共利益或公共道德、公序良俗的信息，不发布其它涉嫌违法或违反本协议及各类规则的信息。</p>
    <p class="content">1.3不对本平台上的任何数据作商业性利用，包括但不限于在未经本平台事先书面同意的情况下以复制、传播等任何方式使用本平台上展示的资料。</p>
    <p class="content">1.4不使用任何装置、软件或例行程序干预或试图干预本平台的正常运作或正在本平台上进行的任何活动。用户不得采取任何将导致不合理的庞大数据负载加诸本平台网络设备的行动。</p>
    <p class="content">1.5不使用网络服务作非法用途；</p>
    <p class="content">1.6不干扰或混乱网络服务；</p>
    <p class="content">1.7遵守所有使用网络服务的网络协议、规定、程序和惯例。</p>

    <p class="content">2、用户了解并同意：</p>
    <p class="content">2.1用户违反上述承诺时，本平台有权依据本协议的约定，做出相应处理或终止向用户提供服务，且无须征得用户的同意或提前通知予用户。</p>
    <p class="content">
      2.2根据相关法令的指定或者本平台服务规则的判断，用户的行为涉嫌违反法律法规的规定或违反本协议和/或规则的条款的，本平台有权采取相应措施，包括但不限于直接屏蔽、删除侵权、降低用户的信用值或单方解除本协议，停止提供相应服务。</p>
    <p class="content">
      2.3对于用户在本平台实施的行为，包括用户未在本平台上实施但已经对本平台及本平台平台的其他注册用户产生影响的行为，本平台有权单方认定用户行为的性质及是否构成对本协议和/或规则的违反，并据此采取相应的处理措施。</p>
    <p class="content">2.4对于用户涉嫌违反承诺的行为对任意第三方造成损害的，用户均应当以自己的名义独立承担所有的法律责任，并应确保本平台免于承担因此产生的损失或增加的费用。</p>
    <p class="content">
      2.5如用户涉嫌违反有关法律或者本协议之规定，使本平台遭受任何损失，或受到任何第三方的索赔，或受到任何行政管理部门的处罚，用户应当赔偿本平台因此造成的损失及（或）发生的费用，包括合理的鉴定费、评估费、律师费用等。</p>

    <p class="title">五、使用规范</p>
    <p class="content">1、用户不得利用本平台危害国家安全、泄露国家秘密，不得侵犯国家社会集体的和公民的合法权益，不得利用本平台制作、复制和传播下列信息：</p>
    <p class="content">1.1煽动抗拒、破坏宪法和法律、行政法规实施的；</p>
    <p class="content">1.2煽动颠覆国家政权，推翻社会主义制度的；</p>
    <p class="content">1.3煽动分裂国家、破坏国家统一的；</p>
    <p class="content">1.4煽动民族仇恨、民族歧视，破坏民族团结的；</p>
    <p class="content">1.5捏造或者歪曲事实，散布谣言，扰乱社会秩序的；</p>
    <p class="content">1.6宣扬封建迷信、淫秽、色情、赌博、暴力、凶杀、恐怖、教唆犯罪的；</p>
    <p class="content">1.7公然侮辱他人或者捏造事实诽谤他人的，或者进行其他恶意攻击的；</p>
    <p class="content">1.8损害国家机关信誉的；</p>
    <p class="content">1.9其他违反宪法和法律法规的；</p>
    <p class="content">1.10未经本平台同意许可进行商业广告行为的。</p>

    <p class="content">2、在接受本平台服务的过程中，用户不得从事下列行为：</p>
    <p class="content">2.1发表、传送、传播、储存侵害他人知识产权、商业秘密权等合法权利的内容。包含但不仅限于病毒、木马等可能对本平台系统造成伤害或影响其稳定性的内容；</p>
    <p class="content">2.2传法、散布或以其他方式实现传播含有受到知识产权法律保护的图像、相片、软件或其他资料的文件；</p>
    <p class="content">
      2.3上载、张贴、发送或传送任何非法、反动、淫秽、粗俗、猥亵的，胁迫、骚扰、中伤他人、诽谤、侵害他人隐私或诋毁他人名誉或商誉的，种族歧视、危害未成年人或其他不适当的信息或电子邮件，包括但不限于资讯、资料、文字、软件、音乐、照片、图形、张贴、信息或其他资料
    </p>
    <p class="content">2.4上载、发送电子邮件或以其它方式传送无权传送的内容（例如内部资料、机密资料）；</p>
    <p class="content">2.5使用任何包含有通过侵犯商标、版权、专利、商业机密或任何一方的其他专有权利的方式，利用本“软件”获得图像或相片的资料或信息；</p>
    <p class="content">
      2.6进行危害计算机网络安全的行为，包括但不限于：使用未经许可的数据或进入未经许可的服务器／帐号；未经允许进入公众计算机网络或者他人计算机系统并删除、修改、增加存储信息；未经许可，企图探查、扫描、测试本平台系统或网络的弱点或其它实施破坏网络安全的行为；企图干涉、破坏本平台系统或网站的正常运行，故意传播恶意程序或病毒以及其他破坏干扰正常网络信息服务的行为；
    </p>
    <p class="content">2.7修改或伪造软件作品运行中的指令、数据、数据包，增加、删减、变动软件的功能或运行效果，不得将用于上述用途的软件通过信息网络向公众传播或者运营；</p>
    <p class="content">2.8在未经本平台书面明确授权前提下，出售、出租、散布、转移或转授权软件和服务或相关的链接或从使用软件和服务或软件和服务的条款中获利，无论以上使用是否为直接经济或金钱收益；</p>
    <p class="content">2.9违背本平台页面公布之活动规则，包括但不限于发布虚假信息、作弊或通过其他手段进行虚假交易；</p>
    <p class="content">2.10冒充任何人或机构，或以虚伪不实的方式谎称或使人误认为与任何人或任何机构有关；</p>
    <p class="content">2.11伪造标题或以其他方式操控识别资料，使人误认为该内容为本平台所传送；</p>
    <p class="content">2.12跟踪或以其他方式骚扰他人；</p>
    <p class="content">2.13其它被本平台视为不适当的行为。</p>
    <p class="content">
      3、本平台会根据用户选择的服务类型向用户提供相应的服务。用户理解并同意，基于用户体验、微信或其服务平台运营安全、平台规则要求及健康发展等综合因素，本平台有权选择提供服务或开展合作的对象，有权决定功能开放、数据接口和相关数据披露的对象和范围，并有权视具体情况中止或终止向存有包括但不限于以下情形的用户或应用提供本服务：
    </p>
    <p class="content">3.1.违反法律法规或本协议规定的；</p>
    <p class="content">3.2.影响使用者体验的；</p>
    <p class="content">3.3.存在安全隐患的；</p>
    <p class="content">3.4.违背服务平台运营原则，或不符合本平台其他管理要求的。</p>

    <p class="content">4、保护用户的信息的安全是本平台的一项基本原则，未经用户的同意，本平台不会向本平台以外的任何公司、组织和个人披露、提供用户的信息，但下列情形除外：</p>
    <p class="content">4.1.据本协议或其他相关协议、规则等约定可以提供的；</p>
    <p class="content">4.2.依据法律法规的规定可以提供的；</p>
    <p class="content">4.3.行政、司法等政府部门要求提供的；</p>
    <p class="content">4.4.用户同意本平台向第三方提供；</p>
    <p class="content">4.5.为解决举报事件、提起诉讼而需要提供的；</p>
    <p class="content">4.6.为防止严重违法行为或涉嫌犯罪行为发生而采取必要合理行动所必须提供的。
    </p>

    <p class="content">5、尽管本平台对用户的信息保护做了极大的努力，但是仍然不能保证在现有的安全技术措施下，用户的信息可能会因为不可抗力或非本平台因素造成泄漏、窃取等，由此给用户造成损失的，用户同意本平台可以免责。
    </p>
    <p class="content">6、本平台有权开发、运营与用户应用相似或相竞争的应用，同时本平台也不保证开放平台上不会出现其他用户提供的与用户应用的功能相竞争的应用。</p>
    <p class="content">7、本平台有权在包括但不限于应用介绍页或安装页面等，向用户阐述该应用为用户开发以及由用户向用户提供客户服务等。</p>

    <p class="title">六、知识产权</p>
    <p class="content">1、本平台提供给用户的服务及应用软件、及相关技术资料、衍生产品的知识产权归本平台所有，用户仅享有本协议项下授予的受限许可。</p>
    <p class="content">
      2、用户不得且不得引起或允许他人：对服务的任何部分（包括但不限于数据结构或由程序产生的类似材料）进行修改、制造衍生品、反汇编、反编译、逆向工程、再造等；向任何第三方授予许可、销售、转移、转让、分销、外包或允许服务站使用、商业利益或提供服务，本协议或相关销售协议允许除外。
    </p>
    <p class="content">
      3、本平台在本服务中提供的信息内容（包括但不限于网页、文字、图片、音频、视频、图表等）的知识产权均归本平台所有，依法属于他人所有的除外。除另有特别声明外，本平台提供本服务时所依托软件的著作权、专利权及其他知识产权均归本平台所有。上述及其他任何本平台依法拥有的知识产权均受到法律保护，未经本平台书面许可，用户不得以任何形式进行使用或创造相关衍生作品。
    </p>

    <p class="title">七、保密</p>
    <p class="content">1、本平台将采取合理确适当的安全措施，帮助用户保护提供的内容免受意外或非法的损失、访问或披露，本平台将依照《隐私协议》保护用户隐私安全。</p>
    <p class="content">2、用户在使用时应正确使用本平台提供的服务，并自行采取一定的安全性措施，包括但不限于使用加密技术、防止内容被擅自访问，并对进行日常存档，因用户自身保护不当产生的损失，本平台不承担责任。</p>
    <p class="content">3、由于用户内容引起的安全漏洞，包括但不限于病毒、木马、蠕虫或内容中包含其他 有害变成管理，或对于用户未按本协议约定使用服务而引起的安全漏洞，用户应当承担责任。</p>

    <p class="title">八、免责声明</p>
    <p class="content">
      <b>1、用户理解并同意：鉴于网络服务的特殊性，本平台有权在无需通知用户的情况下根据平台的整体运营情况或相关运营规范、规则等，可以随时变更、中止或终止部分或全部的服务，若由此给用户造成损失的，用户同意放弃追究责任。</b>
    </p>
    <p class="content">
      <b>2、用户理解并同意：为了向用户提供更完善的服务，本平台有权定期或不定期地对提供本服务的平台或相关设备进行检修、维护、升级等，此类情况可能会造成相关服务在合理时间内中断或暂停的，若由此给用户造成损失的，用户同意放弃追究责任。</b>
    </p>
    <p class="content">
      <b>3、用户理解并同意：本平台的服务是按照现有技术和条件所能达到的现状提供的。本平台会尽最大努力向用户提供服务，确保服务的连贯性和安全性；但本平台能保证其所提供的服务毫无瑕疵，也无法随时预见和防范法律、技术以及其他风险，包括但不限于不可抗力、病毒、木马、黑客攻击、系统不稳定、第三方服务瑕疵、政府行为等原因可能导致的服务中断、数据丢失以及其他的损失和风险。所以用户也同意：即使本平台提供的服务存在瑕疵，但上述瑕疵是当时行业技术水平所无法避免的，其将不被视为违约，同时，由此给用户造成的数据或信息丢失等损失的，用户同意放弃追究责任。</b>
    </p>
    <p class="content">
      <b>4、用户理解并同意：在使用本服务的过程中，可能会遇到不可抗力等风险因素，使本服务发生中断。不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、瘟疫流行和风暴等以及社会事件如战争、动乱、政府行为等。出现上述情况时，本平台将努力在第一时间与相关单位配合，及时进行修复，若由此给用户造成损失的，用户同意放弃追究责任。</b>
    </p>
    <p class="content"><b>5、用户理解并同意：若由于对以下情形导致的服务中断或受阻，给用户造成损失的，用户同意放弃追究责任：</b></p>
    <p class="content"><b>5.1.受到计算机病毒、木马或其他恶意程序、黑客攻击的破坏；</b></p>
    <p class="content"><b>5.2.用户或本平台的电脑软件、系统、硬件和通信线路出现故障；</b></p>
    <p class="content"><b>5.3.用户操作不当；</b></p>
    <p class="content"><b>5.4.用户通过非本平台授权的方式使用本服务；</b></p>
    <p class="content"><b>5.5.其他本平台无法控制或合理预见的情形。</b></p>

    <p class="title">九、其他</p>
    <p class="content">
      1、本平台可能会以网页公告、网页提示、电子邮箱、手机短信、常规的信件传送、用户注册的本服务帐号的管理系统内发送站内信等方式中的一种或多种，向用户送达关于本服务的各种规则、通知、提示等信息，该等信息一经本平台采取前述任何一种方式公布或发送，即视为用户已经接受并同意，对用户产生约束力。若用户不接受的，请用户书面通知本平台，否则视为用户已经接受、同意。
    </p>
    <p class="content">2、若由于用户提供的电子邮箱、手机号码、通讯地址等信息错误，导致用户未收到相关规则、通知、提示等信息的，用户同意仍然视为用户已经收到相关信息并受其约束，一切后果及责任由用户自行承担。</p>
    <p class="content">3、用户也同意本平台或合作伙伴可以向用户的电子邮件、手机号码等发送可能与本服务不相关的其他各类信息包括但不限于商业广告等。</p>
    <p class="content">4、若用户有事项需要通知本平台的，应当按照本服务对外正式公布的联系方式书面通知本平台。</p>
    <p class="content">
      5、本协议内容同时包括《隐私政策》、本协议附件中的协议或规则、本平台可能不断发布的关于本服务的其他相关协议、规则等内容。上述内容一经正式发布，即为本协议不可分割的组成部分，用户同样应当遵守。上述内容与本协议存在冲突的，以本协议为准。一经注册或使用本协议下任何服务，即视为用户已阅读并同意接受本协议及上述内容的约束。本平台有权在必要时单方修改本协议或上述内容，相关内容变更后，如果用户继续使用本服务，即视为用户已接受修改后的相关内容。如果用户不接受修改后的相关内容，应当停止使用相关服务。
    </p>
    <p class="content">6、本协议签订地为中华人民共和国四川省成都市。</p>
    <p class="content">7、本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。</p>
    <p class="content">8、若用户和本平台之间发生任何纠纷或争议，首先应友好协商解决；协商不成功的，双方均同意将纠纷或争议提交本协议签订地有管辖权的人民法院解决。</p>
    <p class="content">9、本协议所有条款的标题仅为阅读方便，本身并无实际含义，不能作为本协议涵义解释的依据。</p>

    <p class="title">十、如何联系我们</p>
    <p class="content">如遇到软件在部分机型功能不稳定属正常状态，在更新到最新版本的前提下，出现此问题会员用户可通过（我的-设置-关于我们-问题反馈）提交问题详细信息。</p>
    <p class="content">当你有其他的投诉、建议相关问题时，你可以将你的问题发送。邮箱faq@yzfuture.cn或寄到如下地址： 成都市高新区天府二街新希望天祥广场A座30楼3005号
      数据及隐私保护中心（收）</p>
    <p class="content">我们将尽快审核所涉问题，并在验证你的用户身份后的三十天内予以回复。</p>

    <div class="company">
      <p class="right-content">成都鱼住未来科技有限公司</p>
      <p class="right-content">最后更新：2024年9月4日</p>
    </div>
  </div>

</template>

<script>
export default {
  data () {
    return {}
  },
  computed: {},
  methods: {}
}
</script>
<style lang="less" scoped>
div {
  padding: 15px 25px;
  font-size: 14px;
  text-align: justify;
}

p.title {
  font-weight: bold;
  margin-top: 15px;
  margin-bottom: 15px;
}

p.content {
  text-indent: 28px;
  margin-bottom: 5px;
}

.company {
  margin-top: 40px;
  margin-bottom: 30px;
}

p.right-content {
  text-indent: 28px;
  margin-bottom: 5px;
  text-align: right;
  margin-right: 30px;
}

p.update-time {
  margin-top: 30px;
  text-align: right;
}

.main-title {
  text-align: center;
  font-weight: bold;
}
</style>
